import gift from "../../assets//images/gift.jpg";

const WishCard = ({ wishData, openWishDataModal }) => {

  const url = wishData.url.length > 20 ? `${wishData.url.substr(0, 20)}...` : wishData.url;

  const handleClick = () => openWishDataModal(wishData)

  return (
    <div className="wishCard cursor-pointer" onClick={handleClick} >
      <img className="w-2/12 mt-3 rounded-full" src={wishData.image ? wishData.image : gift} alt="Un cadeau" />
      <h3 className="w-full mt-4 flexJustifyItemsCenter text-darkOrange font-bold">
        {wishData.title.length > 20 ? `${wishData.title.substr(0, 20)}...` : wishData.title}
      </h3>
      <div className="w-full mt-1 mb-3 flex justify-center gap-1 items-start flex-col">
        <span>
          Prix : <span>{wishData.price}€</span>
        </span>
        <a className="hover:underline" href={wishData.url} target="_blank" rel="noopener noreferrer" >
          {url}
        </a>
      </div>
    </div>
  );
};

export default WishCard;